import React from 'react';
import { Link } from 'react-router-dom';
import LeaguesTable from '../../shared/Tables/LeaguesTable';
import Axios from 'axios';

class LeaguesAdmin extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
			leagues: []
		};

		this.loadLeagues = this.loadLeagues.bind(this);
	}

	componentDidMount() {
		// console.log('LeaguesAdmin: componentDidMount');
		this.loadLeagues();
	}

	loadLeagues() {
		// console.log('LeaguesAdmin: loadLeagues');
		var _this = this;
		Axios.get('/api/leagues').then(function(response) {
			_this.setState({
				leagues: response.data
			})
		});
	}

	render() {
		//console.log('Admin - LeaguesAdmin: render')
		return (
			<div className="row">
			<div className="col-md-12">

				<h5>Ligues</h5>
				<Link to='/admsafe/leagues/add' className="btn btn-primary"> Ajouter une Ligue </Link>
				<br/><br/>

				<div className="card">
					<div className="card-header">
						<i className="fa fa-th-large"></i>      {/* fa-th-large */}
						Ligues
					</div>

					<div className="card-block">
					<LeaguesTable leagues={this.state.leagues} /*handleDeleteLeague={this.handleDeleteLeague} leagueChange={this.props.leagueChange}*//>
					</div>
				</div>
			</div>
			</div>

		);
	}

}

export default LeaguesAdmin;